// eslint-disable-next-line no-restricted-imports
import { State } from 'modules';
// eslint-disable-next-line no-restricted-imports
import { AlertArea, AlertName } from 'modules/state/ui/alerts';

export const isAlertShown = (
  state: State,
  area: AlertArea,
  name: AlertName,
): boolean => {
  return area in state.ui.alerts && state.ui.alerts[area] === name;
};



// WEBPACK FOOTER //
// ./app/gamma/src/selectors/alerts.ts